export default "__VITE_ASSET__DVAZXzp$__"